module.exports = __webpack_public_path__ + "img/9-11-memorial-musium.1ac40060.jpg";